// Header.js
import React from 'react';

const Header = () => {
  return (
    <div className="cli-header" id="cli-mainHeader">
   
      <p className="cli-head1">Our Clients</p>
    
      <div className="cli-para">
        <p className="cli-para1">Empower Your Journey: Subscribe to Premium Services for Unmatched Excellence! Elevate Your Experience with Getmax Solutions Join Us Today for a Service Beyond Compare!</p>
      </div>
    </div>
  );
};

export default Header;
